// extracted by mini-css-extract-plugin
export default {"container":"styles_container__uYTKI","title":"styles_title__iO-0g","chartContainer":"styles_chartContainer__3GTJ3","yearLabels":"styles_yearLabels__8UXDI"};